import { translate } from "app/filters/i18nFilter";

import type { ICategoryDropdownProps } from "./CategoryDropdown";
import { CategoryDropdown } from "./CategoryDropdown";

export const getNoCategoryItem = (textKey?: string) => ({
    id: "no-category",
    get text() {
        return translate(textKey ?? "common.categorypicker.defaultplaceholder.text");
    },
    isCustomCategory: false,
    isChild: false,
});

export const CategoryPicker = ({
    placeHolder = getNoCategoryItem(),
    selectedCategoryId = placeHolder.id,
    ...other
}: ICategoryDropdownProps) => (
    <CategoryDropdown
        {...other}
        placeHolder={placeHolder}
        selectedCategoryId={selectedCategoryId}
    />
);
